import { render, staticRenderFns } from "./BtnLogout.vue?vue&type=template&id=3681ac1a"
import script from "./BtnLogout.vue?vue&type=script&lang=js"
export * from "./BtnLogout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports